var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Box, Button, CircularProgress, } from "@material-ui/core";
export var ButtonLoader = function (_a) {
    var isLoading = _a.isLoading, children = _a.children, disabled = _a.disabled, props = __rest(_a, ["isLoading", "children", "disabled"]);
    return (React.createElement(Button, __assign({ disabled: disabled || isLoading }, props, { endIcon: isLoading && React.createElement(CircularProgress, { size: 15 }) }),
        React.createElement(Box, { display: "flex", alignItems: "center" }, children)));
};
